import type { BeforeSendFn, CaptureResult } from 'posthog-js';

// gloss
const letter = (char: string): string => {
  const lower = char.charCodeAt(0).toString(16);
  const upper = char.toUpperCase().charCodeAt(0).toString(16);
  return `(?:${char}|%(?:25)*(?:${lower}|${upper}))`;
};
const NAME = [...'token'].map(letter).join('');
const ENCODED_EQUALS = '%(?:25)*3D';

const RAW_TOKEN_PARAM = new RegExp(`(^|[?&#"])(${NAME})=[^&#\\s"\\\\]*`, 'gi');
const ENCODED_TOKEN_PARAM = new RegExp(
  `(%(?:25)*(?:26|3F|23)${NAME}${ENCODED_EQUALS})(?:[^&#\\s%"\\\\]|%(?!(?:25)*(?:26|23))[0-9A-Fa-f]{2})*`,
  'gi',
);
const TOKEN_HINT = new RegExp(`${NAME}(?:=|${ENCODED_EQUALS})`, 'i');

// gloss
const redactUrl = (value: string): string =>
  value.replace(RAW_TOKEN_PARAM, '$1$2=[redacted]').replace(ENCODED_TOKEN_PARAM, '$1[redacted]');

// gloss
export const redactTokenFromAnalytics: BeforeSendFn = (event) => {
  if (!event) return event;
  let serialized: string;
  try {
    serialized = JSON.stringify(event);
  } catch {
    return null;
  }
  if (!TOKEN_HINT.test(serialized)) return event;
  return JSON.parse(redactUrl(serialized)) as CaptureResult;
};
